const transactions = [
  {
    tabName: "Offline Payments",
    page: [],
    path: "/transactions/offline-payments",
    authority: "PORTAL",
    rolePermission: "TRANSACTIONS_OFFLINE_PAYMENT",
  },
  {
    tabName: "Offline Payment #",
    page: [],
    path: "/transactions/offline-payments-details",
    authority: "PORTAL",
    rolePermission: "TRANSACTIONS_OFFLINE_PAYMENT",
    showInSidebar: false,
  },
  {
    tabName: "Offline Transactions",
    page: [],
    path: "/transactions/offline-transactions",
    authority: "PORTAL",
    rolePermission: "TRANSACTIONS_OFFLINE_TRANSACTION",
  },
  {
    tabName: "Online Orders",
    page: [],
    path: "/transactions/online-orders",
    authority: "PORTAL",
    rolePermission: "TRANSACTIONS_ONLINE_ORDER",
  },
  {
    tabName: "Online Transactions",
    page: [],
    path: "/transactions/online-transactions",
    authority: "PORTAL",
    rolePermission: "TRANSACTIONS_ONLINE_TRANSACTION",
  },
  {
    tabName: "Online Order #",
    page: [],
    path: "/transactions/online-order-details",
    authority: "PORTAL",
    rolePermission: "TRANSACTIONS_ONLINE_ORDER",
    showInSidebar: false,
  },
];

export default transactions;
